import { useEffect, useState } from "react";
import { MAIN_RESOURCE } from "_common/resources/BaseResourceStore";
import { TPropertyCardMdl, TPropertyListingMdl } from "properties/_models/PropertyMdl";
import { TUnitListingMdl } from "units/_models/UnitMdl";
import { userStore } from "users/_stores/userStore";
import { toast } from "react-toastify";

type UseFavoriteToggle = {
    isFavorite: boolean;
    toggleFavorite: () => void;
};

export const useFavoriteToggle = (
    type: MAIN_RESOURCE,
    item: TPropertyListingMdl | TPropertyCardMdl | TUnitListingMdl,
): UseFavoriteToggle => {
    const [isFavorite, setIsFavorite] = useState(false);
    useEffect(() => {
        try {
            switch (type) {
                case MAIN_RESOURCE.PROPERTIES:
                    setIsFavorite(!!userStore.favoritesProperties.find((property) => property._id === item._id));
                    break;
                case MAIN_RESOURCE.UNITS:
                    setIsFavorite(!!userStore.favoritesUnits.find((unit) => unit._id === item._id));
                    break;
                default:
                    break;
            }
        } catch {
            setIsFavorite(false);
        }
    }, [userStore.favoritesProperties, userStore.favoritesUnits]);

    const toggleFavorite = () => {
        let toggleAction;
        if (!userStore.isLogged) return userStore.openSignInWithModal();
        switch (type) {
            case MAIN_RESOURCE.PROPERTIES:
                toggleAction = userStore.togglePropertyToFavorites(item as TPropertyListingMdl);
                break;
            case MAIN_RESOURCE.UNITS:
                toggleAction = userStore.toggleUnitsToFavorites(item as TUnitListingMdl);
                break;
            default:
                toggleAction = userStore.togglePropertyToFavorites(item as TPropertyListingMdl);
        }

        toggleAction
            .then(() => setIsFavorite(!isFavorite))
            .catch((e) => {
                toast.error(e);
            });
    };

    return { isFavorite, toggleFavorite };
};
